import UpdateBar from "@/pages/home/components/UpdateBar";
import Hero from "@/pages/home/components/Hero";
import FeaturedEntry from "@/pages/home/components/FeaturedEntry";
import MirrorFlow from "@/pages/home/components/MirrorFlow";
import HotRanking from "@/pages/home/components/HotRanking";
import GuideSteps from "@/pages/home/components/GuideSteps";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <UpdateBar />
      <main>
        <Hero />
        <FeaturedEntry />
        <MirrorFlow />
        <HotRanking />
        <GuideSteps />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}